var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id)?_c('span',[(_vm.waiting)?_c('v-progress-linear',{staticClass:"my-2",attrs:{"indeterminate":""}}):_vm._e(),_vm._v(" "+_vm._s(_vm.userInitials)+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }